export default {
  "index": {
    "tencentCompanyEdition": "Tencent Corporation. All rights reserved"
  }
}